function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  padding: 0;\n  margin: 0 auto;\n  max-width: ",
        "px;\n  width: ",
        "px;\n  align-items: center;\n  justify-content: center;\n  @media ",
        " {\n    max-width: 100%;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';
import { mediaQueries, variables } from 'shared/styles';
export default styled(Flex)(_templateObject(), variables.maxWidthLarge, variables.maxWidthLarge, mediaQueries.largeDesktop, variables.maxWidthMed);
